import HeroSlideAnimation from "../helpers/hero-slide-animation";

export default class HeroImage {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.hero-image__section'), el => {
			new HeroImage(el);
		});
	}

	constructor(element) {
		this.element = element;
		this.contentElement = this.element.querySelector('.hero-image__content-inner');
		new HeroSlideAnimation(this.element, this.contentElement);

		if (this.element.classList.contains('hero-image--adapt-mobile-content-box-height')) {
			window.addEventListener('resize', () => this.updateMobileContentBoxHeight());
			this.updateMobileContentBoxHeight();
		}
	}

	updateMobileContentBoxHeight() {
		this.element.querySelector('picture').style.top = (window.innerWidth < 575) ? this.element.querySelector('.hero-image__content-inner').getBoundingClientRect().height + 'px' : null;
	}
}
